import gql from 'graphql-tag';

export const UPDATE_ARTICLES_STARRED_MUTATION = gql`
  mutation UpdateArticlesStarredMutation($articleIds: [ID!]!, $starred: Boolean!) {
    updateArticlesStarred(articleIds: $articleIds, starred: $starred) {
      articles {
        id
        starred
      }
      errors
    }
  }
`;
